import React, { useState } from "react";

const SelectServerModal = ({
    isOpen,
    onClose,
    servers,
    onConfirm,
    isSubmitting,
    confirmLabel = 'Send to Kitchen',
    submittingLabel = 'Sending...',
}) => {
    const [selectedServerId, setSelectedServerId] = useState(null);

    if (!isOpen) return null;

    const handleConfirm = () => {
        if (!selectedServerId) return;
        onConfirm(selectedServerId);
    };

    return (
        <div className="modal modalStyle fade show" style={{ display: "block", background: "rgba(0,0,0,.5)" }} tabIndex="-1">
            <div className="modal-dialog modal-dialog-centered modal-lg">
                <div className="modal-content">

                    <div className="modal-header">
                        <h1 className="modal-title mdTitle">Select a Server</h1>
                        <button type="button" className="btn-close" onClick={onClose} />
                    </div>

                    <div className="modal-body">
                        <div className="modalBodyStyle formStyle">
                            <div className="btnGroup">
                                {(servers || []).map((server) => (
                                    <div key={server.id}>
                                        <input
                                            type="radio"
                                            className="btn-check"
                                            name="quickSendServerRadio"
                                            id={`quick-send-server-${server.id}`}
                                            checked={selectedServerId == server.id}
                                            onChange={() => setSelectedServerId(server.id)}
                                        />

                                        <label className="radioBtn" htmlFor={`quick-send-server-${server.id}`}>
                                            {server.first_name} {server.last_name}
                                        </label>
                                    </div>
                                ))}
                            </div>
                        </div>
                    </div>

                    <div className="modal-footer justify-content-between">
                        <button type="button" className="btn btnLight" onClick={onClose}>
                            Cancel
                        </button>

                        <button
                            type="button"
                            className="btn btnPrimary"
                            onClick={handleConfirm}
                            disabled={!selectedServerId || isSubmitting}
                        >
                            {isSubmitting ? submittingLabel : confirmLabel}
                        </button>
                    </div>

                </div>
            </div>
        </div>
    );
};

export default SelectServerModal;
